import ApiExtension from './api-extension'

export default class Comments extends ApiExtension {
  async count(threadPrefix) {
    return await this.fetch('thread', { id: threadPrefix }, null, {
      format: '',
    })
  }

  async get(threadId) {
    return await this.fetch('thread_comments', { thread_id: threadId })
  }

  async post(threadId, commentText) {
    return await this.fetch(
      'thread_comments',
      { thread_id: threadId },
      {
        method: 'POST',
        body: JSON.stringify({ comment: { comment: commentText } }),
      }
    )
  }
}
